/*
 * Copyright (c) 2023 Bolmate B.V.
 */

import {AwesomeIcon} from '@dvrd/dvr-controls';

import React, {useContext} from 'react';

import Account from '../../../models/accountModel';

import {SELECTED_ACCOUNT_KEY} from '../../../util/constants';

import {onAddAccount} from '../../../util/events';

import {requestPageChangePermission} from '../../../util/pageChanger';

import {saveToLocal} from '../../../util/storageUtil';

import {AppContext} from '../../misc/appContext';

import ContextAccount from './contextAccount';

import {showSnackbar} from '@dvrd/dvr-controls';

export default function ContextAccountController() {
    const context = useContext(AppContext);
    const {account, accounts} = context.accountContext;

    function onChangeAccount(accountId: string) {
        requestPageChangePermission(() => {
            const _account = accounts.find((account: Account) => account.id === accountId);
            if (!_account) return onAddAccount();
            if (_account.id === account?.id) return;
            saveToLocal(SELECTED_ACCOUNT_KEY, _account.id);
            context.onChangeContext({account: _account}, () => {
                showSnackbar(
                    <label>
                        <AwesomeIcon name='random' /> Account gewijzigd naar {_account.labelWithSellerID}
                    </label>,
                    {backgroundColor: 'color-green-whatsapp'}
                );
            });
        });
    }

    return <ContextAccount onChangeAccount={onChangeAccount} />;
}
